import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'form-hidden',
  styleUrls: ['form-hidden.component.sass'],
  template: `<div [formGroup]="group">
    <input type="hidden" [formControlName]="config.name" />
  </div> `,
})
export class FormHiddenComponent implements Field {
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
